(function () {
  document.addEventListener('click', async function (evt) {
    const btn = evt.target.closest('[data-ip-add-to-cart]');
    if (!btn) return;

    const variantId = btn.dataset.ipAddToCart;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      });

      if (!res.ok) throw new Error('Add to cart failed');

      const data = await res.json();

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: data,
            data: {
              source: 'ip-promoted-products',
              itemCount: data.item_count || 1,
            },
          },
        })
      );

      btn.textContent = '✓';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1200);
    } catch (err) {
      console.error('[ip-promoted-products]', err);
      btn.textContent = 'Error';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    }
  });
})();
